import { useEffect, useState } from 'react'

import i18n from 'commons/libs/i18n'
import { Autocomplete } from 'components'
import { TypesValidations } from 'constants/enums'
import { ROUTES } from 'constants/urls'
import type { PaymentMethodsProps } from 'container/CreateOrder/components'
import { Controller, useFormContext } from 'react-hook-form'
import { useMatch } from 'react-router-dom'
import { getPaymentsTerms } from 'services/draft'

import * as S from '../styles'

interface PaymentSelectorProps {
  disabled?: boolean
  defaultPayment?: string
}

export const PaymentSelector = ({ disabled, defaultPayment }: PaymentSelectorProps) => {
  const isCreating = useMatch(ROUTES.orders.getLink('nationalSampleOrder'))
  const { control, setValue, trigger } = useFormContext()

  const [inputAutocomplete, setInputAutocomplete] = useState('')
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethodsProps[]>([])

  useEffect(() => {
    if (!isCreating && defaultPayment) setInputAutocomplete(defaultPayment)

    const fetchPaymentTerms = async () => {
      const returnApi = await getPaymentsTerms({
        cd_canl_dstb: '',
        cd_cond_pgto: '',
        cd_empr: '',
        cd_orgn_vend: '',
        cd_tipo_orde: '',
        fl_orde_tele_vend: TypesValidations.NO,
        qt_rowcount: 999,
      })

      if (returnApi) {
        setPaymentMethods(returnApi)
      }
    }

    fetchPaymentTerms()
  }, [defaultPayment])

  return (
    <>
      <S.FieldWrapper className="div-payment-terms">
        <Controller
          control={control}
          name="cd_cond_pgto"
          render={({ field: { onChange, ref, name }, fieldState: { error } }) => (
            <Autocomplete<PaymentMethodsProps>
              browserAutocomplete="off"
              data={paymentMethods}
              disabled={disabled || !paymentMethods.length}
              error={error?.message}
              input={inputAutocomplete}
              inputId={name}
              label={i18n.t('components.orderHeader.paymentTerms')}
              objDescription={'ds_cond_pgto'}
              objId={'cd_cond_pgto'}
              onInputChange={() => {
                setValue('cd_cond_pgto', '', { shouldDirty: true })
                setValue('ds_cond_pgto', '')
              }}
              placeHolder={i18n.t('common.placeholders.clickToSelect')}
              ref={ref}
              setInput={setInputAutocomplete}
              setOptionSelected={(e) => {
                if (e?.cd_cond_pgto) {
                  onChange(e.cd_cond_pgto)
                  setValue('ds_cond_pgto', e.ds_cond_pgto)
                  trigger(['cd_cond_pgto', 'ds_cond_pgto'])
                }
              }}
              useCodeOnDescription
            />
          )}
          rules={{ required: true }}
        />
      </S.FieldWrapper>
    </>
  )
}

export default PaymentSelector
